import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex items-center justify-center gap-3 py-6" }


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3StonesParameterLoading',
  setup(__props) {

/**
 * Small inline loading animation shown by the itemV3Stones*.vue parameter components
 * while their variants haven't been loaded yet (i.e. while the "active"/matching
 * variant computed is still falsy). Mirrors the color/animation language of the
 * loading overlay in itemV3ParameterBox.vue, just scaled down for inline use.
 */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("span", { class: "relative flex size-8 items-center justify-center" }, [
      _createElementVNode("span", { class: "absolute size-full rounded-full bg-radial-[at_35%_30%] from-[#a57a43] to-[#805b2f] opacity-25 animate-ping" }),
      _createElementVNode("span", { class: "absolute size-6 rounded-full border-[3px] border-[#e7ddcc] border-t-[#8b6536] animate-spin" }),
      _createElementVNode("span", { class: "size-2 rounded-full bg-radial-[at_35%_30%] from-[#a57a43] to-[#805b2f] animate-pulse" })
    ], -1)
  ]))]))
}
}

})